import React from "react";
import PolicesGroupListPageContainer from "./PolicesGroupListPageContainer";

export class PolicesGroupListPage extends React.Component {
  render() {
    return <PolicesGroupListPageContainer {...this.props} />;
  }
}
